import React from 'react'
import Form from '../../components/Form'
import InputText from '../../components/Inputs/InputText'
import FormItem from '../../components/Form/FormItem'
import { useForm } from 'react-hook-form'
import InputNumber from '../../components/Inputs/InputNumber'
import Datepicker from '../../components/Inputs/Datepicker'
import Button from '../../components/General/Button'
import Select from '../../components/Inputs/Select'
import { formatPipe } from '../../utils/utils'
import { Accordion, AccordionDetails, AccordionSummary, Card, Collapse, Typography } from '@mui/material'
import { AiOutlineArrowDown } from 'react-icons/ai'
import { IoIosArrowDown } from 'react-icons/io'
import CurrencyInput from '../../components/Inputs/CurrencyInput'
import Bancrecer from '../../assets/images/bancrecer.svg';
import LogoBNC from '../../assets/images/bnc-original.svg'

const PagoMovilForm : React.FC<IPagoMovilForm> = ({onSubmit, amount, isLoading, disabledInput}) => {


    const form = useForm({
        defaultValues: {
          amount: amount
        },
      })

      const banksOptions = [
        {
          value: '0102',
          text: 'Banco de Venezuela',
        },
        {
          value: '0191',
          text: 'Banco Nacional de Credito',
        },
        {
          value: '0108',
          text: 'Banco Provincial',
        },
        {
          value: '0114',
          text: 'Bancaribe',
        },
        {
          value: '0115',
          text: 'Banco Exterior',
        },
        {
          value: '0163',
          text: 'Banco del Tesoro',
        },
        {
          value: '0134',
          text: 'Banesco',
        },
        {
          value: '0138',
          text: 'Banco Plaza',
        },
        {
          value: '0174',
          text: 'Banplus',
        },
        {
          value: '0169',
          text: 'Mi Banco',
        },
        {
          value: '0157',
          text: 'DEL SUR BU',
        },
        {
          value: '0168',
          text: 'Bancrecer',
        },
        {
          value: '0171',
          text: 'Banco Activo',
        },
        {
          value: '0151',
          text: 'BFC',
        },
        {
          value: '0172',
          text: 'Bancamiga',
        },
        {
          value: '0105',
          text: 'Mercantil',
        },
        {
          value: '0151',
          text: 'BFC',
        },
        {
          value: '0177',
          text: 'BANFANB',
        },
        {
          value: '0175',
          text: 'Bicentenario',
        },
        {
          value: '0137',
          text: 'SOFITASA',
        },
        {
          value: '0166',
          text: 'Agricola',
        },
        {
          value: '0128',
          text: 'Caroni',
        },
        {
          value: '0156',
          text: '100% Banco',
        },
        {
          value: '0104',
          text: 'Venezolano de Credito',
        },
      ]
        
  return (
    <>
      <Form
        form={form}
        classes={`gap-x-2 gap-y-2`}
        onSubmit={(values) => {
          onSubmit({...values, amount: values?.amount || `Bs. ${formatPipe(amount + '')}`})
        }}
      >
        <div className="col-span-12" style={{color: "#102b6d", fontWeight: 500}}>Pago Móvil</div>
        
        <Accordion className='col-span-12 mt-2'>
        <AccordionSummary
          expandIcon={<IoIosArrowDown />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Datos de pago móvil</Typography>
        </AccordionSummary>

        <AccordionDetails>
          <Typography>
          Nombre: Waku Software
          </Typography>

          <Typography>
          Banco: BNC
          </Typography>

          <Typography>
          Telefono: 0412-9697598
          </Typography>

          <Typography>
          RIF: J-413060540          
          </Typography>


        </AccordionDetails>

        </Accordion>

    

          {/* Banco emisor */}
          <FormItem
            name="bank"
            classes="md:col-span-6 sm:col-span-12"
            rules={{ required: 'Es necesario el banco emisor' }}
            defaultValue={banksOptions[0]}
          >
            <Select
              label='Banco emisor'
              options={banksOptions}
            />
          </FormItem>

          {/* Monto */}
          <FormItem
            name="amount"
            classes="md:col-span-6 sm:col-span-12"
            defaultValue={amount || ''}
            rules={{
              required: 'Es necesario el monto',
            }}
          >
            <CurrencyInput disabled={disabledInput} addDecimals={true} mask='Bs. num' label='Monto' />
          </FormItem>

          {/* Número telefónico - Código */}
          <FormItem
            name="phoneCode"
            classes="md:col-span-3 sm:col-span-12"
            rules={{ required: 'Es necesario el código telefónico' }}
            defaultValue={{ value: '0416', text: '0416' }}
          >
            <Select
              label='Código'
              options={[
                { value: '0412', text: '0412' },
                { value: '0414', text: '0414' },
                { value: '0416', text: '0416' },
                { value: '0424', text: '0424' },
                { value: '0426', text: '0426' }
              ]}
            />
          </FormItem>

          {/* Número telefónico - Número */}
          <FormItem
            name="phoneNumber"
            classes="md:col-span-3 sm:col-span-12"
            defaultValue={''}
            rules={{
              required: 'Es necesario el número telefónico',
            }}
          >
            <InputText
              label='Teléfono'
              innerProps={{
                type: 'tel',
                placeholder: '1234567'
              }}
            />
          </FormItem>

          {/* Referencia */}
          <FormItem
            name="ref"
            classes="md:col-span-6 sm:col-span-12"
            rules={{
              required: 'Es necesario el número de referencia',
            }}
          >
            <InputText label='Referencia' />
          </FormItem>

          {/* Fecha de pago */}
          <FormItem
            name="paymentDate"
            classes="md:col-span-6 sm:col-span-12"
            rules={{
              required: 'Es necesario la fecha de pago',
            }}
          >
            <Datepicker label='Fecha de pago' />
          </FormItem>

        <div className="col-span-12 h-full flex flex-row">
          {/* <div className="w-1/2 mr-5 pl-1">
            <Button type="outline" classes="w-full" onClick={() => onCancel()}>
              Cancelar
            </Button>
          </div> */}
          <div className="w-full pr-1 mt-3">
            <Button loading={isLoading} type="primary" classes="w-full" htmlType="submit" disabled={isLoading}>
              Continuar
            </Button>
          </div>
        </div>

        {/* <div
        style={{ height: 1, width: '100%', backgroundColor: '#CFCFCF' }}
        className="col-span-12 mt-3"
      ></div>

      <div className='col-span-12 mt-3 flex flex-col items-center'>
          <label className='text-center text-sm' style={{color: '#7C7C7C'}}>Operación realizada a través de la plataforma de BNC</label>
          <div className='mt-3'>
          <img src={LogoBNC} height={70} width={70}/>
          </div>
      </div> */}

      </Form>
    </>
  )
}

export default PagoMovilForm


interface IPagoMovilForm {
    onSubmit: (values: any) => void
    isLoading: boolean;
    amount: number;
    disabledInput: boolean;
}